<div class="ppk-plot-container d-flex flex-column h-100">
  
  <!-- Toolbar -->
  <div class="plot-toolbar d-flex align-items-center p-2 border-bottom bg-light">
    
    <!-- Solution Quality (Q) -->
    <div class="d-flex align-items-center me-3">
      <label class="me-2 text-muted text-nowrap fw-bold" style="font-size: 0.875rem;">Solution Quality (Q)</label>
      <select class="form-select form-select-sm w-auto" [(ngModel)]="selectedQ" (change)="updatePlot()">
        <option value="ALL">ALL</option>
        <option [ngValue]="1">Q=1</option>
        <option [ngValue]="2">Q=2</option>
        <option [ngValue]="3">Q=3</option>
        <option [ngValue]="4">Q=4</option>
        <option [ngValue]="5">Q=5</option>
      </select>
    </div>

    <!-- Scale (only in Grid mode) -->
    <div class="d-flex align-items-center" *ngIf="!isMapMode">
      <label class="me-2 text-muted fw-bold" style="font-size: 0.875rem;">Scale</label>
      <select class="form-select form-select-sm w-auto" [(ngModel)]="scaleBarCm" (change)="updatePlot()">
        <option *ngFor="let s of scaleOptions" [ngValue]="s.cm">{{s.label}}</option>
      </select>
    </div>

    <!-- Spacer -->
    <div class="ms-auto"></div>

    <!-- Background Selection -->
    <div class="d-flex align-items-center ms-3" *ngIf="currentMode === 'Gnd Trk'">
      <label class="me-2 text-muted fw-bold" style="font-size: 0.875rem;">Background</label>
      <select class="form-select form-select-sm w-auto" [(ngModel)]="backgroundMode" (change)="onBackgroundChange()">
        <option value="Grid">Grid</option>
        <option value="Map">Map</option>
      </select>
    </div>

    <div class="d-flex align-items-center ms-3" *ngIf="isLoading">
      <span class="spinner-border spinner-border-sm text-primary" role="status"></span>
      <span class="small ms-2 text-muted">Loading...</span>
    </div>
  </div>

  <!-- Legend -->
  <div class="p-1 px-3 border-bottom bg-white small text-muted text-start" style="font-size: 0.75rem;">
    Q=1: Fixed, Q=2: Float, Q=3: SBAS, Q=4: DGPS, Q=5: Single
  </div>

  <!-- Plot Area -->
  <div class="plot-area flex-grow-1 position-relative">
    <div *ngIf="errorMsg" class="alert alert-danger m-3">{{ errorMsg }}</div>

    <div #plot class="w-100 h-100" style="position:absolute; top:0; left:0;"></div>

    <div *ngIf="!data && !isLoading && !errorMsg" class="d-flex h-100 align-items-center justify-content-center text-muted">
      No data loaded.
    </div>
  </div>

  <!-- Status Bar -->
  <div class="plot-status-bar p-1 border-top bg-light small text-primary">
    <div class="d-flex justify-content-between mb-1" *ngIf="timeRangeText">
      <div>{{ timeRangeText }}</div>
    </div>
    <div class="d-flex justify-content-between">
      <div>
        <span class="text-success fw-bold me-2">{{ fixRateText }}</span>
        <span class="text-muted">|</span>
        <span class="ms-2">{{ statusText }}</span>
      </div>
      <div class="text-muted">{{ cursorInfo }}</div>
    </div>
  </div>
</div>

